module.exports = __webpack_public_path__ + "res/img_info_m.dbce7d51e15b7931838693c9d3207728.png";